import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'mis-component-library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FooterComponent
  ]
})
export class AppComponent {
  protected readonly copyrightYear = new Date().getFullYear();
}